import React from 'react';
import PrivateRoute from '../hoc/PrivateRoute/PrivateRoute';
import AlterarClienteProcessoPage from '../pages/Manutencao/AlterarClienteProcesso/AlterarClienteProcessoPage';
import AlterarComercialProcessoPage from '../pages/Manutencao/AlterarComercialProcesso/AlterarComercialProcessoPage';
import AlterarPercentuaisProcessoPage from '../pages/Manutencao/AlterarPercentuaisProcesso/AlterarPercentuaisProcessoPage';

function RoutesManutencaoComponents() {
  return (
    <>
      <PrivateRoute
        path="/manutencao/alterar-cliente-processo"
        tipoUsuario="U"
        roles={['2601']}
        exact
        component={AlterarClienteProcessoPage}
      />

      <PrivateRoute
        path="/manutencao/alterar-comercial-processo"
        tipoUsuario="U"
        roles={['2601']}
        exact
        component={AlterarComercialProcessoPage}
      />

      <PrivateRoute
        path="/manutencao/alterar-percentual-recebimento"
        tipoUsuario="U"
        roles={['2601']}
        exact
        component={AlterarPercentuaisProcessoPage}
      />

    </>
  );
}

export const RoutesManutencao = RoutesManutencaoComponents;
